module.exports = __webpack_public_path__ + "static/media/BOXES.e4f8c57f.gif";